module.exports = __webpack_public_path__ + "img/bg_ships_orbits.faff7bdf.png";